import React from 'react';
import CgPopover from 'modules/Common/ui/CgPopover';

export default function CgEntityHoverText({
  triggerElement,
  popoverContent,
  popoverTitle,
  position = 'auto',
  trigger = 'hover',
  className = 'inline-block',
  popoverContentClassName = 'cursor-auto',
  sideOffset = 10,
  mainAxisOffset = 10,
  openDelay = 50,
  closeDelay = 300,
  showWhenComplete = false, // For data check component logic
  isComplete = false, // For data check component logic
  completeTriggerElement = null, // For data check component when complete
  maxWidth,
  open,
  onOpenChange,
}) {
  // Handle the data check special case where we show different content when complete
  if (showWhenComplete && isComplete && completeTriggerElement) {
    return <div className={className}>{completeTriggerElement}</div>;
  }

  return (
    <div className={className}>
      <CgPopover
        maxWidth={maxWidth}
        triggerElement={triggerElement}
        popoverContent={
          <div
            className="space-y-3 min-w-[250px]"
            onClick={(e) => e.stopPropagation()}
          >
            {popoverContent}
          </div>
        }
        popoverTitle={popoverTitle}
        position={position}
        trigger={trigger}
        className={className}
        popoverContentClassName={popoverContentClassName}
        sideOffset={sideOffset}
        mainAxisOffset={mainAxisOffset}
        openDelay={openDelay}
        closeDelay={closeDelay}
        open={open}
        onOpenChange={onOpenChange}
      />
    </div>
  );
}
